import React from 'react';
import { Client } from 'react-stomp-hooks';

import { ANTI_SPAM_DELAY, getPokerRoom } from '../../constants';
import { ChatMessage } from '../../model/chat/ChatMessage';
import { ChatMessageRequest } from '../../model/chat/ChatMessageRequest';
import { PokerRoom } from '../../model/enumeration/PokerRoom';
import { Player } from '../../model/Player';
import chatStore from '../../store/ChatStore';
import { GameTable } from '../../store/state/GameTable';
import { dateFromString } from '../../utils/date.utils';
import { WEventType } from '../../websocket/events/WEventType';

const getArrayOf = (length: number): string[] =>
  Array.from({ length }, (_, i) => i + 1).map(n => String(n));

const unicodeEmoji = [
  '💸',
  '🤝',
  '🙄',
  '😍',
  '🤑',
  '😂',
  '🙌',
  '😐',
  '😱',
  '💰',
  '🙏',
  '😡',
  '🎉',
  '😈',
  '👻',
  '😭',
  '😎',
  '😁',
];

export const getEmojiValues = (): string[] => {
  switch (getPokerRoom()) {
    case PokerRoom.ClubGG: {
      return getArrayOf(27);
    }
    case PokerRoom.PokerMan: {
      return getArrayOf(10);
    }
    default: {
      return unicodeEmoji;
    }
  }
};

export const getEmojiImage = (emojiValue: string): React.ReactNode => {
  switch (getPokerRoom()) {
    case PokerRoom.ClubGG: {
      return (
        <img
          width="40"
          height="40"
          src={`/assets/emoji_clubgg/${emojiValue}.png`}
          alt={`emoji_${emojiValue}`}
        />
      );
    }
    case PokerRoom.PokerMan: {
      return (
        <img
          width="50"
          height="50"
          src={`/assets/emoji_pokerman/${emojiValue}.png`}
          alt={`emoji_${emojiValue}`}
        />
      );
    }
    default: {
      return <span className="regular-emoji">{emojiValue}</span>;
    }
  }
};

export const sendMessageToChat = (
  textMessage: string,
  emoji: boolean,
  chatMessages: ChatMessage[],
  selectedBot: Player,
  table: GameTable,
  client: Client,
  setShowErrorMessage: (showErrorMessage: boolean) => void,
  setText: (text: string) => void,
): void => {
  const prevMessage = chatMessages[chatMessages.length - 1];
  if (
    prevMessage &&
    prevMessage.emoji === emoji &&
    prevMessage.text === textMessage &&
    Math.abs(
      dateFromString(prevMessage.eventTime).getTime() - new Date().getTime(), // anti-spam (delay between messages should be > ANTI_SPAM_DELAY)
    ) < ANTI_SPAM_DELAY
  ) {
    setShowErrorMessage(true);
    setTimeout(() => setShowErrorMessage(false), 5000);
  } else if (client && selectedBot && textMessage) {
    chatStore.sendMessage(client, {
      eventType: WEventType.CHAT_EVENT,
      pid: selectedBot.pid,
      nick: selectedBot.nick,
      text: textMessage,
      emoji,
      tableId: table.id,
      room: table.room,
    } as ChatMessageRequest);
    setText('');
  }
};
